var LanguageService = /** @class */ (function () {
    function LanguageService(api) {
        var _this = this;
        this.fetchLanguages = function (app) {
            return _this.API.get("/languages".concat((app && "?app=".concat(app)) || ''));
        };
        this.fetchLanguageCodes = function () { return _this.API.get('/languages/codes'); };
        this.createLanguage = function (language) { return _this.API.post('/languages', language); };
        this.updateLanguage = function (language) {
            return _this.API.put("/languages/".concat(language.id), language);
        };
        this.updateCodesOfLanguage = function (op, languageId, value) {
            return _this.API.patch("/languages/".concat(languageId, "/codes"), {
                op: op,
                value: value,
            });
        };
        this.deleteLanguage = function (languageId) { return _this.API.delete("/languages/".concat(languageId)); };
        this.setDefaultLanguage = function (languageId) {
            return _this.API.post("/languages/".concat(languageId, "/default"));
        };
        this.API = api;
    }
    return LanguageService;
}());
export { LanguageService };
